import gql from "graphql-tag";

// Shipping Country Queries
export const FETCH_SHIPPING_COUNTRIES = gql`
  query FetchShippingCountries {
    FetchShippingCountries {
      code
      success
      message
      result {
        _id
        countryCode
        countryName
        tax
        phoneCode
        phoneLength
        isActive
      }
    }
  }
`;

// Shipping Method Queries
export const FETCH_SHIPPING_METHODS = gql`
  query FetchShippingMethods($countryCode: String) {
    FetchShippingMethods(countryCode: $countryCode) {
      code
      success
      message
      result {
        _id
        title
        # lowChargeDescription
        regularChargeDescription
        # lowCharge
        # lowChargeThreshold
        regularCharge
        explanation
        country {
          _id
          countryCode
          countryName
        }
        countryCode
        countryName
        isLowChargeApplicable
        isActive
        lowCharges {
          lowCharge
          lowChargeThreshold
          lowChargeDescription
        }
      }
    }
  }
`;
